/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Feedback_EmptyInputs */



/**
* | output |
* | --- |
* | "There is no feedback for this practice conversation yet." |
*
* @param {Practice_Feedback_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_feedback_empty = /** @type {((inputs?: Practice_Feedback_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Feedback_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er is nog geen feedback voor dit oefengesprek.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il n'y a pas encore de feedback pour cet entretien d'entraînement.")
	return /** @type {LocalizedString} */ ("There is no feedback for this practice conversation yet.")
});